<template>
  <div class="console-container">
    <el-card class="console-card">
      <div slot="header" class="clearfix">
        <span>系统控制台</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleConnect">
          {{ isConnected ? '断开连接' : '建立连接' }}
        </el-button>

        <el-button type="primary" @click="download">
          下载历史数据
        </el-button>
        <el-button type="primary" @click="ces">
          测试
        </el-button>
        <el-button type="primary" @click="ces2">
          测试2
        </el-button>
        <el-button type="primary" @click="ces3">
          测试3
        </el-button>
      </div>

      <div class="console-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="message-panel">
              <div class="panel-header">
                <span>接收消息</span>
                <el-button type="text" size="small" @click="clearMessages">清空</el-button>
              </div>
              <div class="message-list" ref="messageList">
                <div v-for="(msg, index) in messages" :key="index" class="message-item"
                  @click="handleMessageClick(msg)">
                  <div class="message-time">{{ msg.receiveTime }}</div>
                  <pre>{{ formatJson(msg.content) }}</pre>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="edit-panel">
              <div class="panel-header">
                <span>编辑区域</span>
                <el-button type="primary" size="small" @click="handleSubmit">提交</el-button>
              </div>
              <div class="edit-area">
                <el-input type="textarea" v-model="editContent" :rows="22" class="custom-textarea"
                  placeholder="请选择左侧消息进行编辑或直接在此输入JSON"></el-input>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from 'axios';
import jsonp from 'jsonp';
import { submitWebsocketMessage, downloadData } from '@/api/otherMG';
export default {
  name: 'Console',
  data() {
    return {
      websocket: null,
      isConnected: false,
      messages: [],
      editContent: '',
      wsUrl: "wss://xjskr.com/websocket"
    }
  },
  methods: {
    handleConnect() {
      if (this.isConnected) {
        this.closeWebSocket()
      } else {
        this.initWebSocket()
      }
    },
    initWebSocket() {
      try {
        this.websocket = new WebSocket(this.wsUrl)
        this.websocket.onopen = this.onWebSocketOpen
        this.websocket.onmessage = this.onWebSocketMessage
        this.websocket.onclose = this.onWebSocketClose
        this.websocket.onerror = this.onWebSocketError
      } catch (e) {
        this.$message.error('WebSocket连接失败')
      }
    },
    closeWebSocket() {
      if (this.websocket) {
        try {
          this.websocket.close()
          this.isConnected = false
          this.$message.success('WebSocket已断开连接')
        } catch (error) {
          console.error('关闭WebSocket连接失败:', error)
          this.$message.error('断开连接失败')
        } finally {
          this.websocket = null
        }
      }
    },
    onWebSocketOpen() {
      this.isConnected = true
      this.$message.success('WebSocket连接成功')
    },
    onWebSocketMessage(e) {
      try {
        const data = JSON.parse(e.data)
        const now = new Date()
        const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`

        this.messages.push({
          content: data,
          receiveTime: timeStr
        })

        this.$nextTick(() => {
          const messageList = this.$refs.messageList
          messageList.scrollTop = messageList.scrollHeight
        })
      } catch (error) {
        console.error('解析消息失败:', error)
      }
    },

    handleMessageClick(msg) {
      this.editContent = JSON.stringify(msg.content, null, 2)
    },

    formatJson(json) {
      return JSON.stringify(json, null, 2)
    },
    clearMessages() {
      this.messages = []
    },
    handleSubmit() {
      try {
        const data = JSON.parse(this.editContent)
        // 调用提交接口
        submitWebsocketMessage(this.editContent)
          .then(res => {
            if (res.success) {
              this.$message.success('提交成功')
            } else {
              this.$message.info(res.msg)
            }
          })
          .catch(err => {
            this.$message.error('提交失败，请稍后再试！')
          })
      } catch (error) {
        this.$message.error('JSON格式错误')
      }
    },
    download() {
      downloadData().then(res => {
        let blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
        console.log('url:', href);
        const a = document.createElement('a'); //创建a标签
        a.style.display = 'none';
        a.href = href; // 指定下载链接
        a.download = '历史数据'; //指定下载文件名
        a.click(); //触发下载
        URL.revokeObjectURL(a.href); //释放URL对象
      });
    },
    ces() {
      jsonp('https://etax.xinjiang.chinatax.gov.cn/wszx-web/api/xj/syhd/appinit/adapter?yhdm=jtyh&data=04A1118B669267612B3804C5A25F5A4FCB5F4DCFAAE2E96C4FB886EB95E2B5092381C4B3528F1C75316ED594FC3BBDA56FAF0C4C8E8B98846AB2790809FDDB43C1A2C0DD146FEE4BE1BD6DBE38F562F909DDA25213E340CAD75D7279FE69B0135CBF38BBA6A050D01FC7FB72B1A57DF2F29007CFA6D87BF964B0790AB9A7B55DD6FC2BC56FD50A750C1F90715F41F1EED2BE73178D779E139309F549D08908064D49E4151273EF6D6590A471647538BF1C2A05B0A5F62D717BD8A6C3B7F0BBE6A465EAD45E92A7C0DA05348E578547B76BF4A626AEE6656B470364620C7C9508A39DA51A4EFB',
        { param: 'callback' },
        (err, data) => {
console.log('JSONP请求失败err:', err);
console.log('JSONP请求失败data:', data);
          if (err) {
            console.log('JSONP请求失败:', err);
          } else {
            console.log('JSONP响应:', data);
          }
        }
      );
    },
    ces2() {
      $.ajax({
        crossDomain: true,
        url: "https://etax.xinjiang.chinatax.gov.cn/wszx-web/api/xj/syhd/appinit/adapter?yhdm=jtyh&data=04A1118B669267612B3804C5A25F5A4FCB5F4DCFAAE2E96C4FB886EB95E2B5092381C4B3528F1C75316ED594FC3BBDA56FAF0C4C8E8B98846AB2790809FDDB43C1A2C0DD146FEE4BE1BD6DBE38F562F909DDA25213E340CAD75D7279FE69B0135CBF38BBA6A050D01FC7FB72B1A57DF2F29007CFA6D87BF964B0790AB9A7B55DD6FC2BC56FD50A750C1F90715F41F1EED2BE73178D779E139309F549D08908064D49E4151273EF6D6590A471647538BF1C2A05B0A5F62D717BD8A6C3B7F0BBE6A465EAD45E92A7C0DA05348E578547B76BF4A626AEE6656B470364620C7C9508A39DA51A4EFB",
        type: "GET",
        dataType: "jsonp",
        success: function (res) {
          console.log(JSON.stringify(res, null, 2));
        },
        error: function (e, f, g) {
          console.log('请求失败e！', e);
          console.log('请求失败f！', f);
          console.log('请求失败g！', g);
        }
      });
    },
    ces3() {
      $.ajax({
        crossDomain: true,
        url: "https://etax.xinjiang.chinatax.gov.cn:6019/wszx-web/api/xj/syhd/appinit/adapter?yhdm=jtyh&data=04977A35EE1C16A402F002AE1A015192B1F86EF4953E0B8FE804FC6FA4F261A1AF889CBCF6ECAD2C904E29EEC09D0698C516514F973CE4389D891DBE915D8A081354310FBB655C3B915C2A638CD4C23E8B1417467E4144D0702588CEDF960B59735390879949242D43C60B4B295C8E649C33DA38454DA22CB43C670CD0244D33E1BCBB4975246BF5524EE35299F6A7A4CB70C385E402373241CE2D226D31D9E1B225C703FF2444270A6B06DA53599D7196B52BE8375281A3B3FBD9E5AAC331FE002247225496B45AAF2AD60A86BA95790A9859BB84C7DC92B289E5D5E40A90D3134D188B4189",
        type: "GET",
        dataType: "jsonp",
        success: function (res) {
          console.log(JSON.stringify(res, null, 2));
        },
        error: function (e, f, g) {
          console.log('请求失败e！', e);
          console.log('请求失败f！', f);
          console.log('请求失败g！', g);
        }
      });
    }
  },
  beforeDestroy() {
    this.closeWebSocket()
  }
}
</script>

<style scoped>
.console-container {
  padding: 20px;
}

.console-card {
  margin-bottom: 20px;
}

.console-content {
  margin-top: 20px;
}

.message-panel,
.edit-panel {
  height: 100%;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.message-list {
  height: 600px;
  overflow-y: auto;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 10px;
  background-color: #fff;
}

.message-item {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f8f8f8;
  border-radius: 4px;
  cursor: pointer;
}

.message-item:hover {
  background-color: #f0f0f0;
}

.message-time {
  font-size: 12px;
  color: #909399;
  margin-bottom: 5px;
}

.edit-area {
  height: 600px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  background-color: #fff;
}

.custom-textarea {
  height: 100%;
}

.custom-textarea>>>.el-textarea__inner {
  height: 100% !important;
  resize: none;
}

pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/views/system/Console.vue